// Empty merchant link settings remain safe, clickable wireframe placeholders.
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('.iem-page [data-iem-placeholder]')) {
    event.preventDefault();
  }
});
